export default "__VITE_ASSET__FB7nBT9D__"